import { estimateLink } from "@constants";
import { useLocation } from "react-router-dom";
import { restoreUTMFromLocalStorage } from "./utmHandler";

const boilerPathName = ["services/boiler", "boiler-replacement"];
const solarPathName = ["services/solar", "solar-panels"];
const contactPathName = ["services/contact_form", "schools-solar-panels","agricultural-solar-panels-landing"];
const commercialcontactPathName = ["services/commercial_contact_form", "commercial-solar-panels"];

export const getEstimateLink = () => {
  const { pathname } = useLocation();
  const isBoiler = !!boilerPathName.find((item) => pathname.includes(item));
  const isSolar = !!solarPathName.find((item) => pathname.includes(item) && !pathname.includes("schools-") && !pathname.includes("-landing") && !pathname.includes("commercial-solar-panels"));
  const isContact = !!contactPathName.find((item) => pathname.includes(item));
  const isCommercialContact = !!commercialcontactPathName.find((item) => pathname.includes(item));

  const appendUTMParams = (link: string) => {
    const utmParams = restoreUTMFromLocalStorage();
    if (!utmParams || Object.keys(utmParams).length === 0) return link;
    const url = new URL(link);
    Object.entries(utmParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
    return url.toString();
  };

  if (isBoiler) {
    const link = appendUTMParams(estimateLink.services.boiler);
    return link;
  }
  if (isSolar) {
    const link = appendUTMParams(estimateLink.services.solar);
    return link;
  }
  if (isContact) {
    return estimateLink.services.contact_form;
  }
  if (isCommercialContact) {
    return estimateLink.services.commercial_contact_form;
  }
  return estimateLink.services["default"];
};

